import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
    >
      <div className="navbar__container">
        {/* Left - Placeholder for symmetry */}
        <div className="navbar__logo-left navbar__logo-left--spacer" />

        {/* Center Content */}
        <div className="navbar__content">
          <img
            src={`${process.env.PUBLIC_URL}/assets/Empress-Garden-Logo.png`}
            alt="Empress Botanical Garden"
            className="navbar__center-logo"
            onError={(e) => {
              console.error("Failed to load Empress Botanical Garden logo");
              e.currentTarget.style.display = 'none';
            }}
          />
          <div className="navbar__text">
            <h1 className="navbar__title">Empress Botanical Garden</h1>
            <p className="navbar__subtitle">
              <span className="navbar__subtitle-accent">Front Gallery</span>
              <span className="navbar__subtitle-divider">•</span>
              Preserving Pune's Natural Heritage
            </p>
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/assets/RRBCEA Final Logo(PNG).png`}
            alt="RRBCEA"
            className="navbar__center-logo"
            onError={(e) => {
              console.error("Failed to load RRBCEA logo");
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>

        {/* Right - Placeholder for symmetry */}
        <div className="navbar__logo-right navbar__logo-right--spacer" />
      </div>

      {/* Decorative bottom border with gradient */}
      <div className="navbar__border" />
    </motion.nav>
  );
};

export default Navbar; 